import { AppContainer } from 'core/components/AppContainer';
import Config from 'core/scripts/Config';
import GlobalFonts from 'core/styles/fonts';
import GlobalStyle from 'core/styles/global';
import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import avo from './avo/avo';

const App = ({ url }) => {
    useEffect(() => {
        avo.initAvo(
            { env: Config.AVO_ENV, webDebugger: false },
            'Suitsupply.com - employee pages',
            null
        );
    }, []);
    return (
        <>
            <GlobalFonts />
            <GlobalStyle />
            <Router>
                <Switch>
                    <Route
                        path="/:localization?/:employeeID/:name"
                        component={AppContainer}
                    />
                    <Route
                        render={() =>
                            (window.location.href = Config.REDIRECT_URL)
                        }
                    />
                </Switch>
            </Router>
        </>
    );
};

export default App;
